export default __webpack_public_path__ + "static/media/72B58668-D8B3-4C07-A3F5-CD19488CEB63.b3a034e3.jpeg";